<template>
  <section class="payment__history payment-history">
    <div class="card card-mob mb-24">
      <div class="payment-card__up !tw-flex !tw-justify-between">
        <h4 class="mt-0 mr-16">
          {{ $t('paymentHistory.yourBalance') }}
        </h4>
        <div class="payment-card__up-content !tw-flex !tw-items-center texts-btn__wrap">
          <div class="texts-wrap">
            <h6 class="mr-16 pr-16">
              {{ $t('paymentHistory.negativeBalanceAfterPayment') }}:
              <span class="text-green">{{ payments_negative_carryover }}</span>
            </h6>
            <h6 class="mr-16">
              {{ $t('paymentHistory.paymentPeriod') }}:
              <span>{{ payment_period }}</span>
            </h6>
          </div>
          <div class="btn-wrap">
            <RequestPayment
              v-if="showPaymentButton"
              v-show="(!waitingApproval && !$store.state.payments.has_approved_not_paid_payment) && $store.state.profile.user.payments_net === 'manual'"
              :change-success="waitingApproval"
              @update:change-success="getWaintingApproval"
              @refresh="refreshBalanceHistory"
            />
            <CancelPaymentRequest
              v-show="(waitingApproval || $store.state.payments.has_approved_not_paid_payment) && $store.state.profile.user.payments_net === 'manual'"
              :disabled="$store.state.payments.has_approved_not_paid_payment"
              :change-success="waitingApproval"
              @update:change-success="getWaintingApproval"
              @refresh="refreshBalanceHistory"
            />
          </div>
        </div>
      </div>
      <div class="payment-card__down row">
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5 class="head text-info">
              {{ $t('paymentHistory.inHold') }}
            </h5>
            <h4
              class="data"
              v-html="formatPrice($store.state.payments.holdBalance)"
            />
          </div>
        </div>
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5 class="head text-success">
              {{ $t('paymentHistory.available') }}
            </h5>
            <h4
              class="data"
              v-html="formatPrice($store.state.payments.availableBalance)"
            />
          </div>
        </div>
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5
              style="color: #cd8a0c;"
              class="head"
            >
              {{ $t('paymentHistory.pendingPayment') }}
            </h5>
            <h4
              class="data"
              v-html="formatPrice($store.state.payments.pendingPayment)"
            />
          </div>
        </div>
        <div class="col-md-3 col-6 card-wrap">
          <div class="card-info">
            <h5 class="head text-black">
              {{ $t('paymentHistory.paidInTotal') }}
            </h5>
            <h4
              class="data"
              v-html="formatPrice($store.state.payments.paidInTotal)"
            />
          </div>
        </div>
      </div>
      <div class="texts-btn__wrap-mob pb-16">
        <div class="texts-wrap pt-12">
          <div class="texts-wrap__table">
            <span>{{ $t('paymentHistory.negativeBalanceAfterPayment') }}</span>
            <span class="text-green">{{ payments_negative_carryover }}</span>
          </div>
          <div class="texts-wrap__table">
            <span>{{ $t('paymentHistory.paymentPeriod') }}</span>
            <span>{{ payment_period }}</span>
          </div>
        </div>
        <div class="btn-wrap pl-16 pr-16">
          <RequestPayment
            v-if="showPaymentButton"
            v-show="(!waitingApproval && !$store.state.payments.has_approved_not_paid_payment) && $store.state.profile.user.payments_net === 'manual'"
            :change-success="waitingApproval"
            @update:change-success="getWaintingApproval"
            @refresh="refreshBalanceHistory"
          />
          <CancelPaymentRequest
            v-show="(waitingApproval || $store.state.payments.has_approved_not_paid_payment) && $store.state.profile.user.payments_net === 'manual'"
            :disabled="$store.state.payments.has_approved_not_paid_payment"
            :change-success="waitingApproval"
            @update:change-success="getWaintingApproval"
            @refresh="refreshBalanceHistory"
          />
        </div>
      </div>
    </div>
    <ElTabs
      type="card"
      class="tab-pane"
    >
      <ElTabPane>
        <template v-slot:label>
          <span>{{ $t('paymentHistory.balanceHistory') }}</span>
        </template>
        <BalanceHistoryTable
          ref="balanceHistory"
          :passed-params="passedParams"
          @fetch="getWaintingApproval"
        />
      </ElTabPane>
      <ElTabPane lazy>
        <template v-slot:label>
          <span>{{ $t('paymentHistory.paymentHistory') }}</span>
        </template>
        <PaymentsHistoryTable :passed-params="passedParams" />
      </ElTabPane>
    </ElTabs>
  </section>
</template>

<script>
import RequestPayment from '@/views/Dashboard/Wallet/RequestPayment.vue';
import CancelPaymentRequest from '@/views/Dashboard/Wallet/CancelPaymentRequest.vue';
import formatCurrency from '@/mixins/format-currency';
import BalanceHistoryTable from '@/views/Dashboard/Wallet/BalanceHistoryTable.vue';
import PaymentsHistoryTable from '@/views/Dashboard/Wallet/PaymentsHistoryTable.vue';

const fetch = (ctx) => ctx.$store.dispatch('getWallets');

export default {
  name: 'Wallet',
  fetch,
  components: {
    RequestPayment,
    CancelPaymentRequest,
    BalanceHistoryTable,
    PaymentsHistoryTable,
  },
  mixins: [
    formatCurrency,
  ],
  props: ['fetchedData', 'passedParams'],
  data() {
    return {
      waitingApproval: 0,
    };
  },
  computed: {
    currencyLabel() {
      return this.getCurrencyLabel(this.$store.state.payments.currencyCode);
    },
    payment_period() {
      return this.$t(`paymentHistory.${this.$store.state.profile.user.payments_net}`);
    },
    payments_negative_carryover() {
      return this.$store.state.profile.user.payments_negative_carryover === false ? this.$t('paymentHistory.no') : this.$t('paymentHistory.yes');
    },
    showPaymentButton() {
      return this.$store.getters.getUser.payments_enabled;
    },
  },
  methods: {
    refreshBalanceHistory() {
      this.$refs.balanceHistory.fetchData(this.$refs.balanceHistory.currentQuery);
    },
    getWaintingApproval(success) {
      return this.$api.getPaymentsHistoryCount({ moderation_status: 'on_review' })
        .then((res) => {
          this.$store.dispatch('getWallets');
          if (!success) {
            this.waitingApproval = res.payload.count;
          }
        });
    },
    formatPrice(amount) {
      const sum = this.$filters.currency(amount, this.currencyLabel, null, {
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: false,
        decimalSeparator: ',',
      });

      if (Math.abs(amount) <= 0.005) {
        return `<span>${sum.replace('-', '')}</span>`;
      }

      return `<span>${sum}</span>`;
    },
  },
};
</script>

<style lang="scss">
// дубликатов нет
@import 'src/assets/theme/default/wallet/wallet';

.payment__history {
  .table-card__header-right-lower {
    flex-grow: 1;
    width:  100%;
  }

  .tab-pane {
    .el-tabs__item {
      text-transform: capitalize;
      color: #303634 !important;
      border: 1px solid #e7ecf1 !important;
      border-bottom: none !important;
      margin-right: 8px;

      &.is-active {
        border: none !important;
        box-shadow: none !important;
        background-color: #fff;
      }
    }

    .el-tabs__header {
      margin-bottom: -1px;
      border: none !important;

      .el-tabs__nav {
        border-radius: 0;
        border: none !important;
      }

      .el-tabs__item {
        font-size: 13px;
        font-weight: 600;
        padding: 0 24px;
      }
    }
  }
}

.payment-history__checkbox {
  align-items: center;

  .checkbox-label {
    margin-bottom: 0;
  }
}
</style>
